/**
 * Resolve a user-shaped record into a friendly display string.
 *
 * Fallback chain: trimmed `display_name` → email local-part → "Unknown user".
 * Guarantees we never surface a raw `user_*` ID in the UI when the user row
 * is missing or has an empty display_name.
 */
export function resolveUserDisplayName(
  user:
    | { display_name?: string | null; email?: string | null }
    | null
    | undefined,
): string {
  const name = user?.display_name?.trim();
  if (name) return name;
  const email = user?.email?.trim();
  if (email) {
    const at = email.indexOf("@");
    return at > 0 ? email.slice(0, at) : email;
  }
  return "Unknown user";
}
